import React, { useState, useCallback, useMemo, useEffect } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import ReturnOrderSelect from "./order-select";
import ReturnReasonSelect from "./reason-seelct";
import ReturnOrderMessage from "./message";
import BottomToTop from "../../../../../../../components/transitions/bottom-to-top";
import ReactDOM from 'react-dom';
import { BlackMask } from "../../../../../../../components/mask";
import { fetchMessageGetList } from "../../../../../../../../api";
import { useApp } from "../../../../../../../hooks/common";

const ReturnOrder = props =>{
    useStyles(cls);
    const { orderPackages, onClose, orderId, onEditor, onRefresh } = props;
    const [type, setType] = useState(0);
    const [reasonList, setReasonList] = useState(null);
    const [unReturnList, setUnReturnList] = useState([]);
    const [alReadyReturnList, setAlReadyReturnList] = useState([]);
    const [returnList, setReturnList] = useState([]);
    const isApp = useApp();

    useEffect(async () =>{
        let response = await fetchMessageGetList("M1799");
        if(response?.code === 200 && response?.result){
            setReasonList(response.result);
        }
    }, []);

    useEffect(() =>{
        if(!!orderPackages){
            const products = orderPackages.reduce((accumulator, currentValue) =>[...accumulator, ...currentValue.products], []);
            const packageList = products?.reduce((prevData, currentData)=>{
                if(currentData?.returnStatus === 1){
                    prevData[0].push(currentData);
                } else if(currentData?.returnStatus === 2){
                    prevData[1].push(currentData);
                } else if(currentData?.returnStatus === 4){
                    prevData[2].push(currentData);
                }
                return prevData;
            }, [[], [], []]);

            setReturnList(packageList[0]?.map(item=>({ ...item, isActive: false, reason: "" })));
            setAlReadyReturnList(packageList[1]);
            setUnReturnList(packageList[2]);
        }
    }, [orderPackages]);

    const updateReturnList = useCallback((order) =>{
        setReturnList(state =>(state?.map((item)=>((!!order?.variantId) && item?.variantId===order?.variantId) ? ({...item, ...order}) : item)));
    }, []);

    return <React.Fragment>
        {
            type === 0 && 
            <ReturnOrderSelect 
                isApp={isApp} 
                orderId={orderId} 
                returnList={returnList} 
                updateReturnList={updateReturnList} 
                setType={setType} 
                setReturnList={setReturnList} 
                reasonList={reasonList} 
                unReturnList={unReturnList} 
                alReadyReturnList={alReadyReturnList} 
                {...props}
            />
        }

        {
            type === 1 && 
            <ReturnReasonSelect 
                onClose={onClose} 
                reasonList={reasonList} 
                setType={setType} 
                returnList={returnList} 
                updateReturnList={updateReturnList} 
            />
        }
        
        {
            type === 2 && 
            <ReturnOrderMessage 
                onClose={onClose} 
                returnList={returnList} 
                orderId={orderId} 
                onEditor={onEditor} 
                setType={setType} 
                onRefresh={onRefresh} 
            />
        }
    </React.Fragment>
}


const ReturnOrderWrapped = props =>{
    return <React.Fragment>
        <BottomToTop in={props.show} className={cls.ReturnOrderSelect}>
            <div>
                <ReturnOrder {...props} />
            </div>
        </BottomToTop>
        {props.show && <BlackMask onClick={props.onClose} />}
    </React.Fragment>
}

const ReturnOrderEditor = props =>{
    if (typeof window === 'undefined') return null;

    return ReactDOM.createPortal(<ReturnOrderWrapped {...props} />,
        document.getElementById('root')
    )
}

export default ReturnOrderEditor;